import _L from "../../util/Labels";
import { Entidad } from "../Entidad";
import { IGrupo, IHorarioDia } from "../entidad/Grupo";
import { _DICC_ASIGNACION_GRADO_GRUPOS, _DICC_GRADO } from "../modulo/Grado";
import { _DICC_ASIGNACION_GRUPO_ALUMNOS } from "../modulo/HorarioAlumno";
import { DataModuloMain } from "../ModuloMain";
import { ModelAdapter } from "./ModelAdapter";

export class MGrupo extends ModelAdapter<IGrupo> implements IGrupo {
    readonly Nombre: string;
    readonly IdGrupo: number;
    readonly IdNivel: number;
    IdEscolaridad: number;
    readonly IdKinder: number;
    readonly EsPrincipal: boolean;
    readonly EnUso: boolean;
    readonly Modificacion: string;

    // =================================================
    // PROPIEDADES ADICIONALES
    // =================================================

    Horario: Array<IHorarioDia>;
    KinderFiltro: Array<number>;
    StrTipoGrupo: string;

    constructor(data: IGrupo) {
        super(data);
        this.KinderFiltro = [this.IdKinder];
        this.StrTipoGrupo = _L(`${this.EsPrincipal ? "grupos.tag_primario" : "grupos.tag_secundario"}`)
        this.Horario = this.getHorarioGrupo();
    }

    private getHorarioGrupo(): Array<IHorarioDia> {
        let horarios = Array<Entidad.IHorarioDia>();
        let tiempos = ["Entrada", "Salida"];
        for (let dia in Entidad.CDiaSemanal) {
            if (isNaN(Number(dia))) {
                let horario = <Entidad.IHorarioDia>undefined;
                tiempos.forEach((tiempo) => {
                    /** @example "LunesEntrada" */
                    const prop = dia + tiempo;
                    const horarioValue = this[prop] || null;
                    if (Boolean(horarioValue)) {
                        if (horario == undefined) {
                            horario = <Entidad.IHorarioDia>{};
                        }
                        horario[tiempo] = horarioValue;
                        horario.IdDia = Number(Entidad.CDiaSemanal[dia]);
                        delete this[prop];
                    }
                });
                if (Boolean(horario)) horarios.push(horario);
            }
        }

        return horarios;
    }

    // =================================================
    // GETTERS ADICIONALES
    // =================================================

    get NombreKinder(): string {
        return DataModuloMain._GetDataValueFieldByName("Escuela", this.IdKinder, "Nombre") || "";
    }

    get NombreGrado(): string {
        return _DICC_GRADO.get(this.IdNivel)?.Nombre || "";
    }

    get NombreEscolaridad(): string {
        if (this.IdEscolaridad) {
            return DataModuloMain._GetDataValueFieldByName("Escolaridad", this.IdEscolaridad, "Nombre") || "";
        } else {
            this.IdEscolaridad = _DICC_GRADO.get(this.IdNivel)?.IdEscolaridad;
            let idEscolaridad = _DICC_GRADO.get(this.IdNivel)?.IdEscolaridad;
            if (idEscolaridad) {
                return (DataModuloMain._GetDataValueFieldByName("Escolaridad", idEscolaridad, "Nombre") || "");
            }
            return "";
        }
    }

    // =================================================
    // METODOS PÚBLICOS
    // =================================================

    public GetAlumnosEnGrupo(includeStudensNoFounded = false): Map<number, Entidad.IAlumno> {
        let asignacionesGrupo = _DICC_ASIGNACION_GRUPO_ALUMNOS.get(this.IdGrupo);
        let alumnosMap = new Map<number, Entidad.IAlumno>();
        asignacionesGrupo?.forEach(asignacionH => {
            let alumno = DataModuloMain._GetReqDataMapById(Entidad.CTipoRequest.Alumno).get(asignacionH.IdNinio);
            if (alumno) {
                alumnosMap.set(asignacionH.IdNinio, alumno);
            } else {
                if (includeStudensNoFounded) {
                    alumnosMap.set(asignacionH.IdNinio, null);
                }
            }
        });
        return alumnosMap;
    }
}